var _rect, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _ellipse, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _ellipse2, _ellipse3, _path6, _ellipse4, _circle11, _ellipse5, _circle12, _path7, _path8, _path9, _path10, _path11, _path12, _circle13, _circle14, _circle15, _circle16, _defs, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#9a4a52"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#a65f66",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 48C32 22 48 18 60 18S88 22 86 48L87 76C87 82 81 84 76 82H44C39 84 33 82 33 76Z",
    fill: "#2a1d1a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#3d3a4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88C50 100 70 100 76 88C72 98 48 98 44 88Z",
    fill: "#d8b99d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 112L34 124M40 108L43 124M52 112L54 124M68 112L66 124M80 108L77 124M90 112L86 124",
    stroke: "#63616e",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 92,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 96,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 99,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 100,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 99,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 96,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 92,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48Q51 44 56 47",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48Q69 44 74 47",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68Q56 65 60 67Q64 65 68 68Q60 75 52 68Z",
    fill: "#9c2f3a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 48C34 27 48 21 60 21S86 27 83 48L80 42C70 44 50 44 40 42Z",
    fill: "#2a1d1a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52C27 28 45 15 62 17C79 19 91 32 83 52C79 47 72 45 60 45C48 45 41 47 35 52Z",
    fill: "#d8c6a4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45Q60 39 82 45",
    stroke: "#a89a7f",
    strokeWidth: 4,
    fill: "none"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 43,
    r: 4,
    fill: "#e3b94a"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 43,
    r: 1.6,
    fill: "#a89a7f"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 66,
    r: 4,
    fill: "none",
    stroke: "#f0c24a",
    strokeWidth: 1.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 66,
    r: 4,
    fill: "none",
    stroke: "#f0c24a",
    strokeWidth: 1.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait30);
export default __webpack_public_path__ + "static/media/player-portrait-30.5950d7dbf5c2a6a0a3b34530c2c573dd.svg";
export { ForwardRef as ReactComponent };